import { FunctionComponent, useState } from 'react';
import BreadCumb from '../../components/common/Breadcrumb';
import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { GET_IDEA_GOALS } from '../../api/query';
import { DELETE_IDEA_GOAL } from '../../api/mutation';
import indicatorIconimg from "../../assets/task/new-indicator-filled_svgrepo.com.svg";
import heartBeatiocn from "../../assets/task/heart-beat_svgrepo.com.svg";
import testintickIcon from "../../assets/task/tick-box-delivery-check-approved-confirm-accept_svgrepo.com.svg";
import backArrow from "../../assets/task/back_arrow.svg";
import Loader from '../../components/common/Loader';
import { useAuth } from '../../context/AuthContext';
import { showError, showSuccess } from '../../components/common/ToastNotification';
import LowPriorityIdeas from '../../components/idea/LowPriorotyIdeas';
import MediumPriorityIdeas from '../../components/idea/MediumPriorityIdeas';
import HighPriorityIdeas from '../../components/idea/HighPriorityIdeas';
import InputsNew from '../../components/common/InputsNew';
import NotifyPopup from '../../components/dashboard/NotifyPopup';

const Ideas: FunctionComponent = () => {
    const navigate = useNavigate()
    const { userInfo, logout } = useAuth()
    const [searchQuery, setSearchQuery] = useState('')
    const [activeFilter, setActiveFilter] = useState('All')
    const [isDeletePopup, setIsDeletePopup] = useState(false)
    const [deleteIdeaId, setDeleteIdeaId] = useState<string | null>(null)

    //api
    const {
        loading,
        data,
        error,
        refetch
    } = useQuery(GET_IDEA_GOALS, {
        fetchPolicy: "no-cache"
    });

    const [deleteIdeaGoal, { loading: deleteLoading }] = useMutation(DELETE_IDEA_GOAL);

    if (error) {
        if ((error.message.includes("Session has expired. Please login again.")) || (error.message.includes("Unauthorized access, please login again."))) {
            showError(error.message)
            logout();
            navigate('/')
        }
    }

    const displayIdeaData = data?.get_idea_goals?.idea_goals

    const filteredIdeas = displayIdeaData?.filter((idea: any) => {
        const matchesSearch = idea?.title?.toLowerCase().includes(searchQuery.toLowerCase()) || 
                             idea?.outcome_name?.toLowerCase().includes(searchQuery.toLowerCase())
        const matchesFilter = activeFilter === 'All' || idea?.goal_for === activeFilter
        return matchesSearch && matchesFilter
    })

    const lowPriority = filteredIdeas?.filter((t: any) =>
        t?.priority === "Low"
    )

    const mediumPriority = filteredIdeas?.filter((t: any) =>
        t?.priority === "Medium"
    )

    const highPriority = filteredIdeas?.filter((t: any) =>
        t?.priority === "High"
    )

    // const closed = displayIdeaData?.tasks?.filter((t: any) =>
    //     t?.priority === "Closed"
    // )

    const handleDeleteClick = (ideaId: string) => {
        setDeleteIdeaId(ideaId);
        setIsDeletePopup(true);
    };

    const handleDeleteConfirm = async () => {
        if (!deleteIdeaId) return;

        try {
            const response = await deleteIdeaGoal({
                variables: {
                    id: parseInt(deleteIdeaId)
                }
            });

            if (response.data?.delete_idea_goal?.status_code === 200) {
                showSuccess(response.data.delete_idea_goal.message || "Idea deleted successfully");
                refetch();
                setIsDeletePopup(false);
                setDeleteIdeaId(null);
            } else {
                showError(response.data?.delete_idea_goal?.message || "Failed to delete idea");
            }
        } catch (err: any) {
            showError(err.message || "An error occurred while deleting the idea");
        }
    };

    return (
        <>
            <div className="w-full relative min-h-screen overflow-hidden flex flex-row items-start justify-center flex-wrap content-start py-40 px-20  mq1490:px-[30px]  mq575:px-5  box-border text-left text-base font-manrope">
                <div className="min-w-full flex flex-col items-start justify-start gap-[24px] ">
                    <BreadCumb />
                    <div className="self-stretch flex flex-row items-center justify-start text-2xl gap-[5px ]">
                        <img className="w-6 relative h-6 overflow-hidden shrink-0 cursor-pointer dark-white-img" alt="" src={backArrow}
                            onClick={() => navigate(-1)}
                        />
                        <h3 className="m-0 flex-1 relative text-inherit font-bold font-inherit max-w-[calc(100%_-_29px)] mq450:text-base dark:text-white">Ideas</h3>
                        <div className="  grid flex-row items-center justify-center  box-border gap-1 text-center text-white">
                            <>
                                <button className=" cursor-pointer flex flex-col items-start justify-start p-[10px] plus-task-btn taskdash-plush-img  py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px]"
                                    onClick={() => {
                                        navigate('/add_idea')
                                    }}
                                > <span className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center grid">Add Idea</span>
                                </button>
                            </>
                        </div>
                    </div>
                    <div className="self-stretch flex flex-row items-center justify-between gap-4 mq950:flex-col mq950:items-start">
                        <div className="flex-1 mq950:w-full">
                            <InputsNew
                                contentPlaceholder="Search by title or outcome..."
                                type="text"
                                value={searchQuery}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchQuery(e.target.value)}
                            />
                        </div>
                        <div className="flex flex-row items-center gap-3 mq950:w-full mq950:overflow-x-auto mq950:pb-2">
                            {['All', 'Product Development', 'Customer Success', 'Marketing'].map((filter) => (
                                <button
                                    key={filter}
                                    onClick={() => setActiveFilter(filter)}
                                    className={`cursor-pointer py-2.5 px-5 mq575:py-2 mq575:px-4 rounded-full font-body-xs-semi-bold text-sm whitespace-nowrap transition-all duration-200 shadow-sm ${
                                        activeFilter === filter
                                            ? 'bg-surface-primary-surface active-btn-ideas text-white border-none shadow-md transform scale-105'
                                            : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 hover:shadow-md hover:scale-102'
                                    }`}
                                >
                                    {filter}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="m-0 self-stretch rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove flex flex-col items-start justify-start p-8 mq575:p-3 box-border gap-spacing-lg max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border">
                        <div className=" goal_main_section_dv  viewdoclist_tabel_blg min-w-full assessorform_main_tbl client-hist-main">
                            <div className=" inner_goal_main_section_dv client-report-dtnamic-tbl">
                                <div className="goal_main_section_row grid grid-cols-3 mq1400:grid-5 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1 mt-[8px]  min-w-full self-stretch flex flex-row items-start justify-start gap-6 mq991:gap-[8px] text-lg">
                                    {/* Low Priority */}
                                    <div className="flex-1 shadow-[0px_5px_5px_rgba(0,_0,_0,_0.1)] rounded  flex flex-col items-start justify-center">
                                        <div className="self-stretch rounded-t rounded-b-none border-whitesmoke border-solid border-[1px] box-border flex flex-row items-center justify-between p-2 gap-0">
                                            <div className="flex flex-row items-center justify-start gap-2 ">
                                                <img className="w-[30px] relative max-h-full shrink-0" alt="" src={indicatorIconimg} />
                                                <div className="rounded-[50px] green-low-pdv  border-whitesmoke border-solid border-[1px] box-border flex flex-row items-center justify-center py-1 px-4">
                                                    <b className="relative">Low Priority</b>
                                                </div>
                                                <div className="w-[30px] rounded-[50px] h-[30px] flex flex-col items-center justify-center p-0.5 box-border text-base">
                                                    <div className="relative font-semibold">{lowPriority && (lowPriority ? lowPriority?.length : 0)}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="self-stretch flex flex-col items-start justify-start p-4 gap-4 text-base green-low-pdv">
                                            {lowPriority && lowPriority?.length > 0 ? (
                                                lowPriority?.map((lp: any) => {
                                                    return (
                                                        <LowPriorityIdeas lp={lp} key={lp.id} onDelete={handleDeleteClick} currentUserId={userInfo?.employee_id} />
                                                    )
                                                })
                                            ) : <>No Idea</>}
                                        </div>
                                    </div>

                                    {/* Medium Priority */}
                                    <div className="flex-1 shadow-[0px_1px_5px_rgba(0,_0,_0,_0.1)] rounded bg-antiquewhite flex flex-col items-start justify-center">
                                        <div className="self-stretch rounded-t rounded-b-none bg-white border-whitesmoke border-solid border-[1px] box-border flex flex-row items-center justify-between p-2 gap-0">
                                            <div className="flex flex-row items-center justify-start gap-2">
                                                <img className="w-[30px] relative max-h-full overflow-hidden shrink-0" alt="" src={heartBeatiocn} />
                                                <div className="rounded-[50px] bg-antiquewhite border-whitesmoke border-solid border-[1px] box-border flex flex-row items-center justify-center py-1 px-4">
                                                    <b className="relative">Medium Priority</b>
                                                </div>
                                                <div className="w-[30px] rounded-[50px] bg-antiquewhite h-[30px] flex flex-col items-center justify-center p-0.5 box-border text-base">
                                                    <div className="relative font-semibold">{mediumPriority && (mediumPriority ? mediumPriority?.length : 0)}</div>
                                                </div>
                                            </div>
                                        </div>
                                        {mediumPriority && mediumPriority?.length > 0 ? (
                                            mediumPriority?.map((mp: any) => {
                                                return (
                                                    <MediumPriorityIdeas mp={mp} key={mp.id} onDelete={handleDeleteClick} currentUserId={userInfo?.employee_id} />
                                                )
                                            })
                                        ) : <span className="self-stretch flex flex-col items-start justify-start p-4 gap-4 text-base h-[100%]">No Idea</span>}
                                    </div>

                                    {/* High Priority */}
                                    <div className="flex-1 shadow-[0px_1px_5px_rgba(0,_0,_0,_0.1)] red-low-pdv  rounded bg-antiquewhite-testing flex flex-col items-start justify-center">
                                        <div className="self-stretch rounded-t rounded-b-none bg-white border-whitesmoke border-solid border-[1px] box-border flex flex-row items-center justify-between p-2 gap-0">
                                            <div className="flex flex-row items-center justify-start gap-2">
                                                <img className="w-[30px] relative max-h-full overflow-hidden shrink-0" alt="" src={testintickIcon} />
                                                <img className="w-[30px] relative max-h-full overflow-hidden shrink-0 hidden" alt="" src="review_svgrepo.com.svg" />
                                                <div className="rounded-[50px] red-low-pdv border-whitesmoke border-solid border-[1px] box-border flex flex-row items-center justify-center py-1 px-4">
                                                    <p className="text-black my-0 darktext-black"><b className="relative">High Priority</b></p>
                                                </div>
                                                <div className="w-[30px] rounded-[50px] red-low-pdv h-[30px] flex flex-col items-center justify-center p-0.5 box-border text-base">
                                                    <p className="my-0 relative font-semibold text-black darktext-black">{highPriority && (highPriority ? highPriority?.length : 0)}</p>
                                                </div>
                                            </div>
                                            <div className="w-6 rounded h-6 flex flex-row items-center justify-center p-2.5 box-border">
                                                <img className="w-3 relative h-3" alt="" src="plus-lg.svg" />
                                            </div>
                                        </div>
                                        <div className="self-stretch flex flex-col items-start justify-start p-4 gap-4 text-base">
                                            {highPriority && highPriority?.length > 0 ? (
                                                highPriority?.map((hp: any) => {
                                                    return (
                                                        <HighPriorityIdeas hp={hp} key={hp.id} onDelete={handleDeleteClick} currentUserId={userInfo?.employee_id} />
                                                    )
                                                })
                                            ) : <>No Idea</>}
                                        </div>
                                    </div>

                                    {/* closed */}
                                    {/* <div className="flex-1 shadow-[0px_1px_5px_rgba(0,_0,_0,_0.1)] rounded bg-honeydew flex flex-col items-start justify-center">
                                        <div className="self-stretch rounded-t rounded-b-none bg-white border-whitesmoke border-solid border-[1px] box-border flex flex-row items-center justify-between p-2 gap-0">
                                            <div className="flex flex-row items-center justify-start gap-2">
                                                <img className="w-[30px] relative max-h-full overflow-hidden shrink-0" alt="" src={archiveSvgrepo} />
                                                <div className="rounded-[50px] bg-honeydew border-whitesmoke border-solid border-[1px] box-border flex flex-row items-center justify-center py-1 px-4">
                                                    <b className="relative">Closed</b>
                                                </div>
                                                <div className="w-[30px] rounded-[50px] bg-honeydew h-[30px] flex flex-col items-center justify-center p-0.5 box-border text-base">
                                                    <div className="relative font-semibold">{closed && (closed[0] ? closed[0]?.goals?.length : 0)}</div>
                                                </div>
                                            </div>
                                            <div className="w-6 rounded h-6 flex flex-row items-center justify-center p-2.5 box-border">
                                                <img className="w-3 relative h-3" alt="" src="plus-lg.svg" />
                                            </div>
                                        </div>
                                        <div className="self-stretch flex flex-col items-start justify-start p-4 gap-4 text-base h-[100%]">
                                            {closed && closed[0]?.goals?.length > 0 ? (
                                                closed && closed[0]?.goals?.map((cg: any) => {
                                                    return (
                                                        <PriorityFourIdeas handleGoalClick={handleIdeaClick} cg={cg} key={cg.id} />
                                                    )
                                                })
                                            ) : <>No goal is closed</>}
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {(loading || deleteLoading) && (
                <Loader />
            )}
            {isDeletePopup && (
                <NotifyPopup
                    showMessage="Do you want to delete this idea?"
                    msgHeading="Delete Idea"
                    onsubmit={handleDeleteConfirm}
                    back={() => {
                        setIsDeletePopup(false);
                        setDeleteIdeaId(null);
                    }}
                    isDelete={true}
                />
            )}
        </>
    );
};

export default Ideas;
